import { createFileRoute } from "@tanstack/react-router";

import RetentionAdmin from "@/components/RetentionAdmin";

// Generated to match `src/app/admin/retention/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/retention")({
  component: RetentionAdmin,
});
